import React, { useState, useRef, useEffect } from 'react'
import Sidebar from '../shared/Sidebar'
import './Layout.scss'
import Navbar from '../shared/Navbar'

const Layout = ({ children }) => {
  const [showMenu, setShowMenu] = useState(false)
  const menuRef = useRef();
  const burgerRef = useRef();

  const handleClick = e => {
    if (menuRef.current.contains(e.target)) {
      // inside click
      return;
    } else if (burgerRef.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setShowMenu(false)
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  return (
    <div className='layout-container'>
      <Sidebar showMenu={showMenu} menuRef={menuRef}/>
      <Navbar showMenu={showMenu} onCLickBurger={() => setShowMenu(!showMenu)} burgerRef={burgerRef} />
      {children}
    </div>
  )

}

export default Layout
